import { render, staticRenderFns } from "./VoucherInvoicesList.vue?vue&type=template&id=3b57ee8f"
import script from "./VoucherInvoicesList.vue?vue&type=script&lang=js"
export * from "./VoucherInvoicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports